import { Tab, TabList, TabPanel, Tabs } from "@mui/joy";
import React from "react";
import TicketListing from "./TicketListing";
import { SxProps } from "@mui/joy/styles/types";
import { useLocation } from "react-router-dom";

interface TicketingPortalProps {
	selected: number;
}
export default function TicketingPortal(props: TicketingPortalProps) {
	const [idx, setIdx] = React.useState(props.selected);
	const location = useLocation();
	React.useEffect(() => {
		const paths = ["alltickets", "recommendations", "sales", "outofservice"];
		const x = location.pathname.toLowerCase().replace("/", "");
		const i = paths.indexOf(x);
		if (i > -1) {
			setIdx(i);
		}
	}, [location]);
	const tabSx = { backgroundColor: "initial !important" } as SxProps;
	return (
		<Tabs value={idx} onChange={(event, value) => setIdx(value as number)}>
			<TabList>
				<Tab color={idx === 0 ? "success" : "neutral"} sx={tabSx}>
					All Tickets
				</Tab>
				<Tab color={idx === 1 ? "success" : "neutral"} sx={tabSx}>
					Recommendations
				</Tab>
				<Tab color={idx === 2 ? "success" : "neutral"} sx={tabSx}>
					Sales Tickets
				</Tab>
				<Tab color={idx === 3 ? "success" : "neutral"} sx={tabSx}>
					Out of Service
				</Tab>
			</TabList>
			<TabPanel value={0}>
				<TicketListing />
			</TabPanel>
			<TabPanel value={1}>
				<TicketListing recommendations={true} />
			</TabPanel>
			<TabPanel value={2}>
				<TicketListing sales={true} />
			</TabPanel>
			<TabPanel value={3}>
				<TicketListing outOfService={true} />
			</TabPanel>
		</Tabs>
	);
}
